<h2 mat-dialog-title>
  {{ isEditMode ? 'Modifier la catégorie' : 'Nouvelle catégorie' }}
</h2>

<!-- Erreur backend -->
<div *ngIf="backendError" class="backend-error-banner">
  <mat-icon>error_outline</mat-icon>
  <span>{{ backendError }}</span>
</div>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="form">

    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Nom</mat-label>
      <input matInput formControlName="nom" placeholder="Ex: Développement logiciel" maxlength="150">
      <mat-hint align="end">{{ form.get('nom')?.value?.length || 0 }}/150</mat-hint>
      <mat-error *ngIf="form.get('nom')?.hasError('required')">Champ obligatoire</mat-error>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Annuler</button>
  <button mat-raised-button color="primary"
          type="button"
          (click)="onSubmit()"
          [disabled]="form.invalid || isSubmitting">
    <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
    {{ isEditMode ? 'Modifier' : 'Créer' }}
  </button>
</mat-dialog-actions>